import { MarketingShell } from "@/components/landing/MarketingShell";
import { Team } from "@/components/landing/Team";
import { SeoHead } from "@/components/useSeo";

// New component for the introductory section
const TeamIntro = () => {
  return (
    <section className="container pt-24 pb-6 md:pt-32 md:pb-8 text-center">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter my-8 md:my-12">
        Cost-Effective, Powerful Self-Hosting
      </h1>

      <p className="max-w-3xl mx-auto text-lg md:text-xl text-muted-foreground mb-8">
        DollarDeploy was born out of frustration with the complexity and unpredictable costs of
        cloud providers. It was created to help developers deploy and manage applications on
        their own terms, leveraging the best hardware for the job without breaking the bank.
      </p>
    </section>
  );
};

function AboutPage() {
  return (
    <MarketingShell>
      <SeoHead path="about" />
      <TeamIntro />
      <Team />
    </MarketingShell>
  );
}

export default AboutPage;
